<template>
  <el-checkbox size="medium" :bind="$attrs" class="elsa-checkbox">
    <slot></slot>
  </el-checkbox>
</template>

<script>
export default {
  name: "Checkbox"
}
</script>

<style>
</style>
